<template>
  <div v-if="bidderTeams.length > 0" class="table-responsive">
    <table class="table table-sm table-striped">
      <thead>
        <tr>
          <th>Nome</th>
          <th>Cargo/Função</th>
          <th>E-mail</th>
          <th class="text-center">Dedicação ao projeto</th>
          <th class="text-center">Status do Usuário</th>
          <th class="text-center">Acessa Plataforma</th>
          <th v-if="canEditProject" class="text-center">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="bidderTeam in bidderTeams" :key="bidderTeam.id">
          <td>{{ bidderTeam.name }}</td>
          <td>
            {{ bidderTeam.role }}
            {{ bidderTeam.function ? `/${bidderTeam.function}` : '' }}
          </td>
          <td>{{ bidderTeam.email }}</td>
          <td class="text-center">
            {{ bidderTeam.dedicationTime }}
            <span
              v-if="canEditProject"
              role="button"
              class="text-primary"
              @click="
                $emit('editBidderTeamProject', {
                  projectBidderId: projectBidderId,
                  projectBidderTeamId: bidderTeam.id,
                })
              "
            >
              (Alterar)
            </span>
          </td>
          <td class="text-center" v-html="statusTranslate(bidderTeam.status)" />
          <td
            class="text-center"
            v-html="platformAccessTranslate(bidderTeam.platformAccess)"
          />
          <td v-if="canEditProject" class="text-center">
            <button
              type="button"
              class="btn btn-outline-danger btn-icon rounded-pill"
              title="Remover Usuário da Equipe Técnica do Proponente"
              @click="
                $emit('deleteBidderTeamProject', {
                  projectBidderId: projectBidderId,
                  projectBidderTeamId: bidderTeam.id,
                })
              "
            >
              <i class="ph-trash" />
            </button>
            <button
              v-if="bidderTeam.status === statusAguardando"
              type="button"
              class="btn btn-outline-warning btn-icon rounded-pill ms-2"
              title="Editar Dados do Usuário"
              @click="$emit('editUser', bidderTeam.userId)"
            >
              <i class="ph-pencil" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div v-else>
    <p class="mb-0">Este proponente não possui nenhuma equipe técnica</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { statusTranslate, platformAccessTranslate } from '@/utils/strings'
import StatusEnum from '@/enum/statusEnum'

export default {
  name: 'ListBidderTeamsProject',

  props: {
    projectId: {
      type: String,
      required: true,
    },
    projectBidderId: {
      type: String,
      required: true,
    },
    reloadListBidderTeams: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      bidderTeams: [],
      statusTranslate,
      platformAccessTranslate,
    }
  },

  computed: {
    ...mapGetters(['canEditProject']),

    statusAguardando() {
      return StatusEnum.AGUARDANDO
    },
  },

  watch: {
    reloadListBidderTeams: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getBidderTeams()
          this.$emit('reloadListBidderTeams', false)
        }
      },
      immediate: true,
    },
  },

  methods: {
    async getBidderTeams() {
      try {
        this.bidderTeams = await this.$store.dispatch('getProjectBidderTeams', {
          projectId: this.projectId,
          projectBidderId: this.projectBidderId,
        })
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    this.getBidderTeams()
  },
}
</script>
